import { modifier } from 'ember-modifier';

/** Delay before the smooth scroll, matching the mixin's animateTask timeout. */
const SCROLL_DELAY_MS = 500;

/**
 * On insert, after a short delay, smooth-scroll the closest
 * `.scroll-top-on-insert` ancestor (or the element itself) back to the top.
 *
 * Octane replacement for the `base-beebee` mixin's `animateTask` +
 * `didInsertElement` DOM work (mixin-removal Phase 1.4). Apply in a template:
 * `<div {{scroll-top-on-insert}}>`.
 */
var scrollTopOnInsert = modifier(element => {
  const timer = setTimeout(() => {
    const parent = element.closest('.scroll-top-on-insert');
    if (parent) {
      parent.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, SCROLL_DELAY_MS);
  return () => clearTimeout(timer);
});

export { scrollTopOnInsert as default };
//# sourceMappingURL=scroll-top-on-insert.js.map
